import React from 'react';
import { useDragLayer } from 'react-dnd';
import styled from 'styled-components';

import { reset } from '../../../utils/styled-reset';
import { DragPreviewContent } from './drag-preview';

const CURSOR_OFFSET_PX = 12;

/**
 * Custom drag layer that positions the file/folder preview with position: fixed
 * using the drag monitor's client offset. This avoids relying on the native
 * setDragImage(), which can fail in production (e.g. S3/CloudFront, iframes)
 * and cause the preview to appear at the DOM node position (bottom-left)
 * instead of following the cursor.
 */
const FileManagerDragLayer = () => {
  const { isDragging, item, itemType, currentOffset } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || !currentOffset || (itemType !== 'File' && itemType !== 'Folder')) {
    return null;
  }

  const draggedItems = item?.selectedEntities;
  if (!draggedItems?.length) {
    return null;
  }

  return (
    <Layer
      style={{
        left: currentOffset.x + CURSOR_OFFSET_PX,
        top: currentOffset.y + CURSOR_OFFSET_PX,
      }}
    >
      <DragPreviewContent draggedItems={draggedItems} />
    </Layer>
  );
};

const Layer = styled.div`
  ${reset}

  position: fixed;
  z-index: 9999;
  pointer-events: none;
  padding: 0.5em;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 0.5em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  strong {
    font-weight: 500;
  }
`;

export { FileManagerDragLayer };
